import { render, staticRenderFns } from "./Xp.vue?vue&type=template&id=6fdb767e&"
import script from "./Xp.ts?vue&type=script&lang=js&"
export * from "./Xp.ts?vue&type=script&lang=js&"
import style0 from "./Xp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
